import { IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';
import { format, parseISO } from 'date-fns';

import { IcEdit, IcEye } from '@/assets/images';
import { IAgency, IKase, IUser } from '@/models';
import { BookingStatus, IBooking } from '@/pages/JMS/Managament/types/booking';
import { formatPersonName } from '@/utils';

const inmate = (): Partial<GridColDef> => ({
  sortable: true,
  filterable: true,
  renderCell: (params: { row: IBooking }) => {
    const identity = params?.row?.identity;
    return formatPersonName(identity);
  },
});

const agency = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) => {
    return (params?.row?.details?.agency as IAgency)?.name;
  },
});

const initialBookingDate = (): Partial<GridColDef> => ({
  sortable: true,
  renderCell: (params: { row: IBooking }) => {
    if (!params.row?.details?.initialBooking) {
      return;
    }
    return format(parseISO(params.row?.details?.initialBooking), 'MM/dd/yyyy');
  },
});

const scheduledRelease = (): Partial<GridColDef> => ({
  renderCell: (params: { row: IBooking }) => {
    if (!params.row?.details?.scheduledReleaseDate) {
      return;
    }
    return format(
      parseISO(params.row?.details?.scheduledReleaseDate),
      'MM/dd/yyyy',
    );
  },
});

const caseNumber = (): Partial<GridColDef> => ({
  sortable: true,
  renderCell: (params: { row: IBooking }) =>
    (params.row.details?.kase as IKase)?.number || '',
});

const bookingOfficer = (): Partial<GridColDef> => ({
  sortable: true,
  renderCell: (params: { row: IBooking }) =>
    formatPersonName(params.row.details?.bookingOfficer as IUser),
});

const bookingType = (): Partial<GridColDef> => ({
  sortable: true,
  renderCell: (params: { row: IBooking }) => params.row.details?.type,
});

const bookingNumber = (): Partial<GridColDef> => ({
  sortable: true,
  renderCell: (params: { row: IBooking }) => params.row?.details?.number,
});

const actions = (
  onView?: (inmateId?: string) => void,
  onEdit?: (inmateId?: string) => void,
): Partial<GridColDef> => ({
  sortable: false,
  filterable: false,
  renderCell: (params: { row: IBooking }) => {
    return (
      <div className="flex items-center">
        <IconButton onClick={() => onView?.(params.row?._id)}>
          <IcEye className="text-gray-400" />
        </IconButton>
        {params.row.status === BookingStatus.IN_PROGRESS ? (
          <IconButton onClick={() => onEdit?.(params.row?._id)}>
            <IcEdit className="text-gray-400" />
          </IconButton>
        ) : null}
      </div>
    );
  },
});

export const bookingCols = (
  onView?: (inmateId?: string) => void,
  onEdit?: (inmateId?: string) => void,
) => {
  return {
    inmate,
    agency,
    bookingOfficer,
    bookingNumber,
    caseNumber,
    scheduledRelease,
    bookingType,
    initialBookingDate,
    actions: () => actions(onView, onEdit),
  };
};
